import { postLoginRedirectAction } from './actionTypes'


export const postLoginRedirect = (data: string | undefined = undefined) => ({ type: postLoginRedirectAction, payload: data })

